import React from 'react'
export default function Header() {
  return (
    <header>
      <h4 className="text-right">myweather</h4>
    </header>
  )
}
